(function(){
    'use strict'; 
    angular.module('Services').service('AccountingOtherChargesTable', AccountingOtherChargesTable); 
    AccountingOtherChargesTable.$inject = [
        'TableLiteFactory'
    ]; 

    function AccountingOtherChargesTable(
        TableLiteFactory
    ){
        return function(otherChargesData, currency, isViewMode){
            const tableData = {
                config: {
                    tableMinHeight: '200px', 
                    noPagination: true, 
                    noHeaders: false, 
                    noItemView: true, 
                    noFooter: true
                }, 
                headers: [{
                    label: 'DESCRIPTION', 
                    viewName: 'description', 
                    fieldName: 'description'
                },{
                    label: 'DURATION', 
                    viewName: 'durationValue', 
                    fieldName: 'durationValue'
                },{
                    label: 'AMOUNT',
                    viewName: 'amountValue', 
                    fieldName: 'amountValue'
                }], 
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(callback) {
                    callback({content: otherChargesData})
                }, 
                callbackFormat:['success', 'error', 'filter'], 
                postRequestCallback: data => {
                    buildTableData(data); 
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20, 
                    page: 0, 
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                if(!data) { return tableData; }
                tableActions.initializeTableData(data); 
                
                angular.forEach(data.content, row => {
                    row.description = row.name; 
                    row.amountValue = {
                        url : '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value : row.amount, 
                        valueType : 'monitary',
                        id: row.description + 'amount', 
                        addOnLabel: currency,
                        fullWidth: true,
                        disabled: isViewMode
                    };
                    
                    row.durationValue = {
                        url : '/templates/directives/intellectual-table/body-cells/time.html',
                        value : row.durationInSeconds, 
                        id: row.description + 'time', 
                        disabled: isViewMode
                    };
                    tableData.data.push(row);
                });
            }

            function getTableData(){
                return tableData.data;
            }

            function getOtherChargesTotal() {
                let total = 0;
                tableData.data.forEach(data => {
                    total += Number(data.amountValue.value);
                });
                return total;
            }

            this.getOtherChargesTotal = getOtherChargesTotal;
            this.getTableData = getTableData;
            this.tableData = tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/AccountingOtherChargesTable.js